import { gql } from 'graphql.macro'
import SensorEditFragment from '../../lib/SensorEditFragment'

export default gql`
  query Sensor($id: ID!) {
    sensor(id: $id) {
      ...SensorEditFragment
    }
  }

  ${SensorEditFragment}
`
